import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css'; // استيراد أيقونات Bootstrap
import '../Style/Slider.css';

import home from '../Images/home.png';
import muslim from '../Images/muslim.png';
import brain from '../Images/brain.png';
import book from '../Images/book.png';
import sun from '../Images/sun.png';
import girl from '../Images/girl.png';
import man from '../Images/man.png';
import boy from '../Images/boy.png';
import check from '../Images/check.png';
import octopus from '../Images/octopus.png';
import rocket from '../Images/rocket.png';

const images = [
  home, muslim, brain, book, sun,
  girl, man, boy, check, octopus, rocket, muslim
];

function ImageSlider() {
  const [currentPage, setCurrentPage] = useState(0);
  const [imagesPerPage, setImagesPerPage] = useState(getImagesPerPage());

  function getImagesPerPage() {
    return window.innerWidth < 768 ? 2 : 4;
  }

  useEffect(() => {
    const handleResize = () => {
      const newImagesPerPage = getImagesPerPage();
      setImagesPerPage(newImagesPerPage);
      setCurrentPage(0); // رجع لأول صفحة لو الشاشة اتغيرت
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalPages = Math.ceil(images.length / imagesPerPage);
  const startIndex = currentPage * imagesPerPage;
  const visibleImages = images.slice(startIndex, startIndex + imagesPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };

  return (
    <div className="container m-auto m-0 p-0 row my-4">
      <div className="slider-container col p-0  d-flex justify-content-center align-items-center">

        {/* زرار الشمال */}
        <div
          className="slider-btn left-btn me-3 d-flex align-items-center"
          onClick={handlePrev}
          style={{ visibility: currentPage === 0 ? 'hidden' : 'visible', cursor: 'pointer' }}
        >
          <i className="bi bi-arrow-left m-auto  p-2"></i>
        </div>

        {/* الصور */}
        <div className="gap-1 d-flex justify-content-center flex-wrap">
          {visibleImages.map((img, index) => (
            <div
              className="shadow rounded bg-white d-flex align-items-center justify-content-center img-container m-1"
              key={startIndex + index}
              style={{ width: '120px', height: '120px' }}
            >
              <img
                src={img}
                alt={`img-${startIndex + index}`}
                className="img-fluid img-animation"
                style={{ maxHeight: '100%', objectFit: 'contain', width: "70%" }}
              />
            </div>
          ))}
        </div>

        {/* زرار اليمين */}
        <div
          className="slider-btn right-btn ms-3 d-flex align-items-center"
          onClick={handleNext}
          style={{
            visibility: currentPage >= totalPages - 1 ? 'hidden' : 'visible',
            cursor: 'pointer'
          }}
        >
          <i className="bi bi-arrow-right m-auto  p-2"></i>
        </div>
      </div>
    </div>
  );
}

export default ImageSlider;
